import React, { useMemo, useState } from "react";
import { NonTagFilterTypes } from "@lifeat/shared/task-management/TaskFilterTypes";
import LifeAtCheckbox from "@common/LifeAtCheckbox/LifeAtCheckbox";
import { DropdownMenuComponents } from "@common/LifeAtDropdownMenuV2/DropdownMenuComponents";
import { LifeAtBodyPrimary } from "@common/LifeAtText/LifeAtText";
import { useTaskListContext } from "../TaskListContext";
import { TaskFilterButton } from "./TaskFilterButton";
import { DropdownItem } from "./TaskTagDropdownComponents";

const FILTER_OPTIONS_LABEL = "Progress:";
const TRIGGER_LABEL = "Filter";

const FILTER_OPTIONS: { label: string; value: NonTagFilterTypes }[] = [
    { label: "Hide Completed", value: "status" },
    { label: "Today", value: "today" },
    { label: "Overdue", value: "overdue" },
    { label: "Unscheduled", value: "unscheduled" },
];

export function TaskFilterDropdown() {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const { filters, toggleOpenStatusFilter, toggleTodayFilter, toggleOverdueFilter, toggleUnscheduledFilter } =
        useTaskListContext();

    const selectedFilters = useMemo(() => {
        const ret = new Set<NonTagFilterTypes>();
        for (const filter of filters) {
            if (filter.type !== "tag" && filter.type !== "project") {
                ret.add(filter.type);
            }
        }
        return ret;
    }, [filters]);

    const handleToggleFilter = (filter: NonTagFilterTypes) => {
        switch (filter) {
            case "today":
                toggleTodayFilter();
                break;
            case "overdue":
                toggleOverdueFilter();
                break;
            case "status":
                toggleOpenStatusFilter();
                break;
            case "unscheduled":
                toggleUnscheduledFilter();
                break;
        }
    };

    return (
        <DropdownMenuComponents.Root onOpenChange={(isOpen: boolean) => setIsDropdownOpen(isOpen)}>
            <DropdownMenuComponents.Trigger>
                <TaskFilterButton label={TRIGGER_LABEL} count={selectedFilters.size} isOpen={isDropdownOpen} />
            </DropdownMenuComponents.Trigger>
            <DropdownMenuComponents.Content>
                <DropdownMenuComponents.HeaderItem label={FILTER_OPTIONS_LABEL} />
                {FILTER_OPTIONS.map(({ label, value }) => (
                    <DropdownItem
                        key={value}
                        onClick={() => {
                            handleToggleFilter(value);
                        }}
                    >
                        <LifeAtCheckbox checked={selectedFilters.has(value)} />
                        <LifeAtBodyPrimary>{label}</LifeAtBodyPrimary>
                    </DropdownItem>
                ))}
            </DropdownMenuComponents.Content>
        </DropdownMenuComponents.Root>
    );
}
